import { ConstraintDrillFracInterferenceInteractingTargetFormationBase } from './base/constraint-drill-frac-interference-interacting-target-formation-base';

export class ConstraintDrillFracInterferenceInteractingTargetFormation extends ConstraintDrillFracInterferenceInteractingTargetFormationBase { }